import clsx from 'clsx';
import React from 'react';
import ReactDOM from 'react-dom';
import useStyles from './BackdropStyles';
var Backdrop = function (_a) {
    var _b;
    var show = _a.show, onClick = _a.onClick;
    var element = document.getElementById('backdrop');
    var styles = useStyles();
    return element
        ? ReactDOM.createPortal(React.createElement("div", { className: clsx(styles.backdrop, (_b = {},
                _b[styles.backdropOpen] = show,
                _b)), onClick: onClick }), element)
        : null;
};
Backdrop.defaultProps = {
    onClick: function () { },
};
export default Backdrop;
